var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"btmComp",staticClass:"logo-bottom",class:{ 'bar-bottom': _vm.isBar }},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"sImg",attrs:{"src":_vm.cSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }